import { CalendarAvailablePage, CalendarEventMetadata, CalendarEvents, CalendarPayload, CalendarSearchPayload } from '@/types/CalendarType'
import axios from 'axios'
import { ILoggingService } from './LoggingService'

export default class CalendarService {
    private readonly _logging: ILoggingService
    private readonly baseUrl = '/calendar'

    constructor(logging: ILoggingService) {
        this._logging = logging
    }


    public async getCalendarEvents(payload: CalendarSearchPayload): Promise<CalendarEvents> {
        const url = `${this.baseUrl}/events/search`
        try {
            return (await axios.post(url, payload)).data
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async getAvailableSources(): Promise<CalendarAvailablePage[]> {
        const url = `${this.baseUrl}/sources`
        try {
            return (await axios.get(url)).data.result
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }

    }


    public async upsertCalendarField(calendarField: CalendarPayload): Promise<void> {
        const url = `${this.baseUrl}/events`
        try {
            (await axios.post(url, calendarField))
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async deleteCalendarField(calendarField: CalendarEventMetadata): Promise<void> {
        const url = `${this.baseUrl}/events`
        try {
            await axios.delete(`${url}/${calendarField.id}`)
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }
}
